// ./src/lib/PlayerApi.js

import fetch from 'unfetch';
import Auth from './Auth';

const baseUri = process.env.VUE_APP_BASE_URI;
const requestTimeout = 5e3; // 15 seconds

export const ERRORS = {
  COMMON_ERROR: 'common error',
  GAME_NOT_FOUND: 'game not found',
  NETWORK_ERROR: 'network error',
  TOO_MANY_REQUESTS: 'too many requests',
};

function RequestError(data) {
  Error.call(this, JSON.stringify(data));

  this.name = 'RequestError';
  this.data = data;
  this.message = data.message;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, RequestError);
  } else {
    this.stack = (new Error()).stack;
  }
}

RequestError.prototype = Object.create(Error.prototype);

/**
 *
 * @param {Response} resp
 */
const parseResponse = (resp) => {
  if (resp.ok) {
    if (resp.status === 204) return null; // empty OK response

    return resp.json();
  }

  return resp.json()
    .then((data) => {
      throw new RequestError({
        code: resp.status,
        message: resp.statusText,
        data,
        retry: resp.headers.get('retry-after'),
      });
    });

  // throw new RequestError({
  //   code: resp.status,
  //   message: resp.statusText,
  //   raw: resp,
  //   retry: resp.headers.get('retry-after'),
  // });
};

const getAuthHeader = () => {
  const token = Auth.getAuth();
  if (!token) return {};

  return { Authorization: `Bearer ${token}` };
};

const requestTimeoutFunc = () => new Promise((_, reject) => {
  setTimeout(() => {
    reject(new Error(ERRORS.COMMON_ERROR));
  }, requestTimeout);
});

const fetchRequest = (url) => {
  const headers = { ...getAuthHeader() };

  return fetch(url, { headers })
    .then(parseResponse);
};

const fetchPostRequest = (url, data) => {
  const headers = {
    'Content-Type': 'application/json',
    ...getAuthHeader(),
  };

  return fetch(url,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    })
    .then(parseResponse);
};

const toQuery = obj => (
  Object.keys(obj)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join('&')
);

const promisedRequest = url => Promise.race([
  fetchRequest(url),
  requestTimeoutFunc(),
]);

/**
 *
 * @param {string} url
 * @param {object} data
 *
 * @returns {Promise<any>}
 */
const promisedPostRequest = (url, data) => Promise.race([
  fetchPostRequest(url, data),
  requestTimeoutFunc(),
]);

export default {
  /**
   * checks game by id
   * @param {string} selector
   */
  getGameInfo(selector) {
    const url = `${baseUri}/games/schedule/${selector}`;

    return Promise.race([
      fetchRequest(url),
      requestTimeoutFunc(),
    ]);
  },

  // eslint-disable-next-line no-unused-vars
  getGameByCode(code) {
    throw new Error('Not implemented');
    // const url = `${baseUri}/games/${code}`;

    // return Promise.race([
    //   fetchRequest(url),
    //   requestTimeoutFunc(),
    // ]);
  },

  getRating(selector) {
    const url = `${baseUri}/games/online-games/team-rating?game_part_selector=${selector}`;
    const generalRatingUrl = `${url}&rating_type=r_general`;
    const lolRatingUrl = `${url}&rating_type=r_lol`;

    return Promise.race([
      Promise.all([
        fetchRequest(generalRatingUrl),
        fetchRequest(lolRatingUrl),
      ]),
      requestTimeoutFunc(),
    ]);
  },

  // send answers
  sendAnswers(data) {
    const url = `${baseUri}/games/online-games/answers`;

    return Promise.race([
      fetchPostRequest(url, data),
      requestTimeoutFunc(),
    ]);
  },

  registerTeam(gameId, teamName, teamCity = null) {
    const url = `${baseUri}/games/online-games/register-user`;

    const data = {
      game_part_selector: gameId,
      username: teamName,
      city: teamCity,
    };

    return Promise.race([
      fetchPostRequest(url, data),
      requestTimeoutFunc(),
    ]);
  },

  auth: {
    getCode(params) {
      const url = `${baseUri}/otp-auth/code?${toQuery(params)}`;
      return promisedRequest(url);
    },

    checkCode(params) {
      const url = `${baseUri}/otp-auth`;
      return promisedPostRequest(url, params);
    },
  },

  teams: {
    list() {
      const url = `${baseUri}/teams`;
      return promisedRequest(url);
    },

    create(data) {
      const url = `${baseUri}/teams`;

      return promisedPostRequest(url, data);
    },
  },
};
